import React, { FC, useState } from 'react';
import { inject, observer } from 'mobx-react';
import {
    Theme,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { StoreModel } from 'models/Index';
import { Services, CassetteEvents } from 'helpers';

interface CashAcceptorCassetteEventsEmulatorProps {}
interface CashAcceptorCassetteEventsEmulatorPropsInjected
    extends CashAcceptorCassetteEventsEmulatorProps {
    Store: StoreModel;
}

const useStyles = makeStyles((theme: Theme) => {
    return {
        dialog: {
            zIndex: 1500,
        },
        footer: {
            justifyContent: 'center',
        },
        emulatorButton: {
            position: 'absolute',
            top: theme.spacing(2),
            right: theme.spacing(2),
            zIndex: 1500,
        },
    };
});

const CashAcceptorCassetteEventsEmulator: FC<
    CashAcceptorCassetteEventsEmulatorProps
> = (props) => {
    const {
        Store: { peripheryStatus },
    } = props as CashAcceptorCassetteEventsEmulatorPropsInjected;
    const classes = useStyles();

    const [open, setOpen] = useState(false);

    return (
        <>
            {!open && (
                <Button
                    className={classes.emulatorButton}
                    draggable={true}
                    onClick={() => setOpen(true)}
                    variant='primary'
                >
                    Cassette Events Emulator
                </Button>
            )}
            <Dialog
                className={classes.dialog}
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle component='div'>
                    <Typography
                        variant='h4'
                        align='center'
                        style={{ fontWeight: 'normal' }}
                    >
                        Cassette Events Emulator
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography
                        variant='h5'
                        align='center'
                        style={{ fontWeight: 'normal' }}
                    >
                        {`Cassette Status: ${
                            peripheryStatus.isCassetteInserted
                                ? 'INSERTED'
                                : 'REMOVED'
                        }`}
                    </Typography>
                </DialogContent>
                <DialogActions className={classes.footer}>
                    <Button
                        variant='primary'
                        onClick={() => {
                            const event = new CustomEvent(
                                CassetteEvents.CassetteInsertedEventRaised
                            );
                            document.dispatchEvent(event);
                        }}
                    >
                        <Typography variant='button'>
                            Insert Cassette
                        </Typography>
                    </Button>
                    <Button
                        variant='primary'
                        onClick={() => {
                            const event = new CustomEvent(
                                CassetteEvents.CassetteRemovedEventRaised
                            );
                            document.dispatchEvent(event);
                        }}
                    >
                        <Typography variant='button'>
                            Remove Cassette
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default inject(Services.STORE)(
    observer(CashAcceptorCassetteEventsEmulator)
);
